import { onlinePoints, onlineCompare } from "@/mocks/home";
import Reveal from "@/pages/home/components/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function OnlineReading() {
  return (
    <section id="online" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <Reveal>
        <SectionHeading
          tag="在线看"
          title="网页版在线看网址怎么用"
          desc="不想安装 APP 时，网页版是更轻量的选择。了解它的特点与局限，就能判断什么时候用网页版、什么时候装 APP 更合适。"
        />
      </Reveal>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {onlinePoints.map((item, idx) => (
            <Reveal key={item.title} delay={idx * 60}>
              <div className="h-full rounded-lg border border-background-200 bg-background-100/60 p-5">
                <span className="w-11 h-11 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading font-bold text-foreground-950 text-base">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="lg:col-span-5" delay={120}>
          <div className="h-full rounded-lg border border-background-200 bg-background-50 overflow-hidden">
            <div className="px-5 py-4 border-b border-background-200 bg-background-100/60">
              <h3 className="font-heading font-bold text-foreground-950 text-base">网页版 vs APP 对照</h3>
            </div>
            <table className="w-full text-left text-sm">
              <thead>
                <tr className="text-foreground-500 font-label text-xs">
                  <th className="px-5 py-3 font-medium">对比项</th>
                  <th className="px-5 py-3 font-medium">网页版</th>
                  <th className="px-5 py-3 font-medium">APP</th>
                </tr>
              </thead>
              <tbody>
                {onlineCompare.map((row) => (
                  <tr key={row.item} className="border-t border-background-200">
                    <td className="px-5 py-3.5 text-foreground-900 font-medium whitespace-nowrap">{row.item}</td>
                    <td className="px-5 py-3.5 text-foreground-600">{row.web}</td>
                    <td className="px-5 py-3.5 text-secondary-800">{row.app}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="px-5 py-4 border-t border-background-200 bg-primary-50">
              <p className="text-sm text-primary-900 flex items-start gap-2">
                <i className="ri-lightbulb-line mt-0.5"></i>
                结论：临时浏览用网页版即可；追更频率高、需要离线缓存或提醒时，再从官方渠道安装 APP。
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}